import React, { useState } from "react";
import Header from '../Integration/Header';
import BarraMenu from "../Integration/BarraMenu";
import '../../Css/AboutUs.css';
import Db_Team from '../../JSON/db_Team.json';
import AboutImg from '../Integration/AboutImg';
import image from "../../IMG/sam.jpg"
import image1 from "../../IMG/elmira.jpg"
import image2 from "../../IMG/touaki.png"
import image3 from "../../IMG/ines.jpg"



const About = () => {


const [pic , setPic]=useState([image,image1,image2,image3])


  return (
    <div className="about-page">
      <Header />
      <BarraMenu />

      <section className="about-intro">
        <h2>Sobre a Tou Aki</h2>
        <p>
          A Tou Aki é uma plataforma de e-commerce e prestação de serviços,
          conectando empresas e profissionais para fortalecer a economia nacional.
        </p>
      </section>

      <section className="team-section">
        <h3>Nosso Time</h3>

        <div className="team-grid">
          {Db_Team.Team.map((e, i) => (
            <AboutImg
              key={i}
              Nome={e.Nome}
              cargo={e.Cargo}
              Formacao={e.Formacao}
              urlpic={pic?.[i]}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
